<!-- 租赁合同 -->
<template>
  <div class="contract-management-container">
    <!-- 1. 顶部汇总统计卡片 -->
    <div class="summary-header">
      <div
        v-for="(item, index) in summaryCards"
        :key="index"
        class="summary-card"
      >
        <div class="summary-label">{{ item.label }}</div>
        <div class="summary-value" :style="{ color: item.color }">
          {{ item.value }} <span class="arrow-up">个</span>
        </div>
      </div>
    </div>

    <!-- 2. 检索筛选条件区域 -->
    <div class="filter-wrapper">
      <div class="search-form">
        <div class="form-item">
          <span class="label">合同编号：</span>
          <el-input
            v-model="filters.contractNo"
            placeholder="请输入"
            size="small"
            style="width: 140px"
          />
        </div>
        <div class="form-item">
          <span class="label">资源编号/名称：</span>
          <el-input
            v-model="filters.resourceNoAndName"
            placeholder="请输入"
            size="small"
            style="width: 160px"
          />
        </div>
        <div class="form-item">
          <span class="label">租客名称：</span>
          <el-input
            v-model="filters.partyBName"
            placeholder="请输入"
            size="small"
            style="width: 140px"
          />
        </div>
        <div class="form-item">
          <span class="label">租控状态：</span>
          <el-select
            v-model="filters.currentStatus"
            placeholder="请选择"
            size="small"
            style="width: 120px"
          >
            <el-option
              v-for="(item, index) in currentStatusList"
              :label="item.name"
              :value="item.value"
              :key="index"
            />
          </el-select>
        </div>
        <div class="form-item">
          <span class="label">缴费状态：</span>
          <el-select
            v-model="filters.paymentStatus"
            placeholder="请选择"
            size="small"
            style="width: 120px"
          >
            <el-option
              v-for="(item, index) in paymentStatusList"
              :label="item.name"
              :value="item.value"
              :key="index"
            />
          </el-select>
        </div>
        <div class="button-group">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="search()"
            >查询</el-button
          >
          <el-button size="small" icon="el-icon-refresh" @click="clearSearch()"
            >重置</el-button
          >
          <el-button size="small" icon="el-icon-upload2">导出</el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            class="btn-add-contract"
            @click="openAddContract()"
            >新增合同</el-button
          >
          <el-button
            type="primary"
            size="small"
            icon="el-icon-document-add"
            class="btn-add-intent"
            @click="openAddLOI()"
            >新增意向书</el-button
          >
        </div>
      </div>
    </div>

    <!-- 3. 数据表格 -->
    <div class="table-container">
      <el-table
        :data="contractList"
        size="mini"
        border
        stripe
        :header-cell-style="{
          backgroundColor: '#F9F9F9',
          color: '#333',
          fontWeight: 'bold',
        }"
        style="width: 100%"
      >
        <el-table-column type="selection" width="40" align="center" />
        <el-table-column
          prop="contractNo"
          label="合同编号"
          width="120"
          align="center"
        />
        <el-table-column
          label="文档类型"
          prop="contractType"
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            <span
              :class="[
                'doc-tag',
                scope.row.contractType === 'INTENTION'
                  ? 'bg-orange'
                  : 'bg-blue',
              ]"
            >
              {{ scope.row.contractType === "INTENTION" ? "意向书" : "合同" }}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="signStatusLabel"
          label="签署状态"
          width="90"
          align="center"
        />

        <el-table-column
          prop="resourceNo"
          label="资源编号"
          width="110"
          align="center"
        />

        <el-table-column
          prop="resourceName"
          label="资源名称"
          min-width="150"
          align="center"
        />

        <el-table-column
          label="资源类型"
          prop="resourceType"
          min-width="70"
          align="center"
        >
          <template #default="{ row }">
            {{ _commonFormatter(row, "resourceType") }}
          </template>
        </el-table-column>
        <!--        <el-table-column-->
        <!--          prop="communityName"-->
        <!--          label="所属项目"-->
        <!--          min-width="130"-->
        <!--          align="center"-->
        <!--        />-->
        <el-table-column
          prop="partyBName"
          label="租客名称"
          min-width="120"
          align="center"
        />
        <el-table-column
          prop="partyBPhone"
          label="租客电话"
          min-width="120"
          align="center"
        />
        <el-table-column
          prop="rentalArea"
          label="面积(㎡)"
          min-width="120"
          align="center"
        />
        <el-table-column
          prop="unitPrice"
          label="租金单价"
          min-width="120"
          align="center"
        />
        <el-table-column
          prop="price"
          label="月租金"
          min-width="120"
          align="center"
        />
        <el-table-column
          prop="signDate"
          label="签约日期"
          min-width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="expiryDate"
          label="到期日期"
          min-width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column label="租控状态" width="90" align="center">
          <template slot-scope="scope">
            <span :class="['status-cell', 'status-' + scope.row.rentStatus]">
              {{ _commonFormatter(scope.row, "currentStatus") }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="缴费状态" width="120" align="center">
          <template slot-scope="scope">
            <span :class="['pay-status', 'text-' + scope.row.paymentStatus]">
              {{ _commonFormatter(scope.row, "paymentStatus") }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="280" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleDetailOpen(scope)">
              查看
            </el-button>
            <el-button type="text" size="mini" @click="handleEditContract(scope)">
              合同编辑
            </el-button>
            <!-- 发起签署：暂隐藏 -->
            <!--
            <el-button
              v-if="scope.row.contractType === 'CONTRACT' && _canInitiateSign(scope.row)"
              type="text"
              size="mini"
              @click="handleInitiateSign(scope)"
            >
              发起签署
            </el-button>
            -->
            <!-- 是意向书的话，转为合同 -->
            <template v-if="scope.row.contractType === 'INTENTION'">
              <el-button
                type="text"
                size="mini"
                @click="transtoContract(scope)"
              >
                转为合同
              </el-button>
            </template>
            <!-- 是合同的话，可以收缴和解约 -->
            <template v-else-if="scope.row.contractStatus == 'EXECUTING'">
              <el-button
                type="text"
                size="mini"
                @click="openPayDialogRow(scope)"
              >
                收缴
              </el-button>
              <el-button
                type="text"
                size="mini"
                class="text-red"
                @click="breakContract(scope)"
              >
                解约
              </el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <!-- 4. 分页器 -->
      <div class="pagination-bar">
        <span>共 {{ contractTotal }} 条</span>
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="currentPageSize"
          layout="prev, pager, next, sizes"
          :total="contractTotal"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 右侧抽屉 -->
    <!-- 右侧抽屉详情 -->
    <el-drawer
      :visible.sync="drawerVisible"
      direction="rtl"
      size="45%"
      :with-header="false"
      custom-class="custom-contract-drawer"
    >
      <div class="drawer-content">
        <!-- 头部标题 -->
        <div class="drawer-header">
          <div class="header-left">
            <i
              class="el-icon-close close-btn"
              @click="drawerVisible = false"
            ></i>
            <span class="title">{{ currentContractNo }} - 合同详情</span>
          </div>
        </div>

        <!-- 页签切换 -->
        <div class="tabs-wrapper">
          <el-tabs v-model="activeTab" @tab-click="handleTabClick">
            <el-tab-pane label="基本信息" name="basic"></el-tab-pane>
            <el-tab-pane label="租金记录" name="rent"></el-tab-pane>
            <el-tab-pane label="关联资源" name="resource"></el-tab-pane>
          </el-tabs>
        </div>

        <!-- 滚动内容区 -->
        <div class="scroll-body">
          <!-- 1. 基本信息页签 -->
          <div v-show="activeTab === 'basic'" class="tab-content">
            <div class="section-card">
              <h3 class="section-title">合同信息</h3>
              <div class="info-grid">
                <div
                  v-for="(item, index) in basicInfo"
                  :key="index"
                  class="info-item"
                >
                  <div class="info-label">{{ item.label }}</div>
                  <!-- 租控状态 -->
                  <div class="info-value" v-if="item.key === 'currentStatus'">
                    <span :class="['status-cell', 'status-' + item.value]">
                      {{ _commonFormatter(item, "value.currentStatus") }}
                    </span>
                  </div>
                  <!-- 资源类型 -->
                  <div
                    class="info-value"
                    v-else-if="item.key === 'resourceType'"
                  >
                    {{ _commonFormatter(item, "value.resourceType") }}
                  </div>

                  <!-- 支付方式 -->
                  <div class="info-value" v-else-if="item.key === 'rentCycle'">
                    {{ _commonFormatter(item, "value.rentCycle") }}
                  </div>

                  <div v-else class="info-value">
                    <span>{{ item.value }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="section-card">
              <h3 class="section-title">附件</h3>

              <!-- 暂无附件（空状态） -->
              <el-empty
                v-if="attachmentList.length === 0"
                description="暂无附件"
                :image-size="80"
              >
              </el-empty>
              <div v-else class="attachment-list">
                <div
                  v-for="(file, index) in attachmentList"
                  :key="index"
                  class="attachment-item"
                >
                  <div class="file-info">
                    <!-- 可以根据文件类型动态切换图标，这里统一使用文档图标 -->
                    <i class="el-icon-document file-icon"></i>
                    <span class="file-name" :title="file.name">{{
                      file.name
                    }}</span>
                    <span class="file-size" v-if="file.size"
                      >({{ formatFileSize(file.size) }})</span
                    >
                  </div>
                  <div class="file-actions">
                    <el-button
                      type="text"
                      size="small"
                      icon="el-icon-download"
                      @click="handleDownload(file)"
                    >
                      下载
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 2. 租金记录页签 -->
          <div v-show="activeTab === 'rent'" class="tab-content">
            <div class="action-bar">
              <el-button
                type="primary"
                size="small"
                icon="el-icon-plus"
                @click="openPayDialog()"
                >收缴租金</el-button
              >
            </div>
            <div class="section-card no-padding">
              <el-table
                :data="rentRecords"
                style="width: 100%"
                stripe
                :header-cell-style="tableHeaderStyle"
              >
                <el-table-column
                  v-for="item in rentColumns"
                  :key="item.key"
                  :prop="item.key"
                  :label="item.label"
                >
                  <template slot-scope="scope">
                    <div v-if="item.key === 'paymentStatus'">
                      <!-- 缴费状态 -->
                      <span :class="'status-payment' + scope.row[item.key]">
                        {{ _commonFormatter(scope.row, "paymentStatus") }}
                      </span>
                    </div>
                    <span v-else>{{ scope.row[item.key] }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- 3. 关联资源页签 -->
          <div v-show="activeTab === 'resource'" class="tab-content">
            <div class="section-card">
              <div class="info-grid single-column">
                <div
                  v-for="(item, index) in resourceInfo"
                  :key="index"
                  class="info-item"
                >
                  <div class="info-label">{{ item.label }}</div>
                  <div class="info-value">{{ item.value }}</div>
                </div>
              </div>
              <div class="footer-actions">
                <el-button type="primary" size="small">查看资源详情</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>

    <!-- 新增/编辑合同 共用弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="addDialogVisible"
      width="1200px"
      top="2vh"
      custom-class="add-contract-dialog"
      :close-on-click-modal="false"
      @close="resetContractForm"
    >
      <el-form
        :model="contractForm"
        :rules="contractRules"
        ref="contractFormRef"
        label-position="top"
        class="contract-form-grid"
      >
        <!-- 第一行: 资产类型 & 资源编号 -->
        <div class="form-row">
          <el-form-item label="资产类型" prop="resourceType" class="flex-1">
            <el-select
              v-model="contractForm.resourceType"
              placeholder="请选择资产类型"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in resourceTypeList"
                :label="item.name"
                :value="item.value"
                :key="index"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="资源编号" prop="resourceId" class="flex-1">
            <el-select
              v-model="contractForm.resourceId"
              placeholder="请选择资源"
              style="width: 100%"
            >
              <el-option
                v-for="item in resourcePageData"
                :key="item.id"
                :label="item.resourceName"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </div>

        <!-- 第二行: 出租方 & 合同名称 -->
        <div class="form-row">
          <el-form-item label="合同名称" prop="contractName" class="flex-1">
            <el-input
              v-model="contractForm.contractName"
              placeholder="请输入合同名称"
            />
          </el-form-item>
          <el-form-item label="出租方" prop="partyaId" class="flex-1">
            <el-select
              v-model="contractForm.partyaId"
              placeholder="请选择出租方"
              style="width: 100%"
            >
              <el-option
                v-for="item in partyaList"
                :key="item.partyaId"
                :label="item.partyA"
                :value="item.partyaId"
              />
            </el-select>
          </el-form-item>
        </div>

        <!-- 第二行: 租客名称 & 租客电话 -->
        <div class="form-row">
          <el-form-item
            label="租客名称"
            label-width="100%"
            prop="partyBName"
            class="flex-1"
          >
            <el-input
              v-model="contractForm.partyBName"
              placeholder="请输入租客名称"
            />
          </el-form-item>
          <el-form-item label="租客电话" prop="partyBPhone" class="flex-1">
            <el-input
              v-model="contractForm.partyBPhone"
              placeholder="请输入租客联系方式"
            />
          </el-form-item>
        </div>

        <!-- 第三行: 租客地址 & 签约日期 -->
        <div class="form-row">
          <el-form-item label="租客地址" prop="partyBAddress" class="flex-1">
            <el-input
              v-model="contractForm.partyBAddress"
              placeholder="请输入租客地址"
            />
          </el-form-item>
          <el-form-item label="签约日期" prop="signDate" class="flex-1">
            <el-date-picker
              v-model="contractForm.signDate"
              type="date"
              placeholder="选择签约日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </div>

        <!-- 第四行: 到期日期 (单行或半宽) -->
        <div class="form-row">
          <el-form-item label="到期日期" prop="expiryDate" class="flex-1">
            <el-date-picker
              v-model="contractForm.expiryDate"
              type="date"
              placeholder="选择到期日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <div class="flex-1">
            <el-form-item label="合同金额" prop="contractAmount" class="flex-1">
              <el-input
                v-model.number="contractForm.contractAmount"
                placeholder="元"
              />
            </el-form-item>
          </div>
        </div>

        <!-- 第五行: 租金单价 & 月租金 -->
        <div class="form-row">
          <el-form-item label="租金单价" prop="unitPrice" class="flex-1">
            <el-input
              v-model.number="contractForm.unitPrice"
              placeholder="元/㎡/月"
            />
          </el-form-item>
          <el-form-item label="月租金" prop="price" class="flex-1">
            <el-input v-model.number="contractForm.price" placeholder="元/月" />
          </el-form-item>
        </div>

        <!-- 第六行: 支付方式 & 押金金额 -->
        <div class="form-row">
          <el-form-item label="支付方式" prop="rentCycle" class="flex-1">
            <el-select
              v-model="contractForm.rentCycle"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in rentCycleList"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="押金金额" prop="deposit" class="flex-1">
            <el-input v-model.number="contractForm.deposit" placeholder="元" />
          </el-form-item>
        </div>

        <!-- 合同备注（多行输入框） -->
        <el-form-item label="合同备注" prop="content" class="contract-content-item">
          <el-input
            v-model="contractForm.content"
            type="textarea"
            :rows="3"
            placeholder="请输入合同备注"
          />
        </el-form-item>

        <!-- 附件上传 -->
        <el-form-item label="附件上传" prop="url">
          <el-upload
            action="#"
            :on-success="handleUploadSuccess"
            :before-upload="beforeUpload"
            :http-request="handleUpload"
            :limit="1"
            :file-list="fileList"
            class="contract-uploader"
          >
            <el-button size="small" icon="el-icon-upload2">
              上传合同扫描件、租客身份证明
            </el-button>
          </el-upload>
        </el-form-item>
      </el-form>

      <!-- 底部操作按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeAddDialog()" size="medium">关闭</el-button>
        <el-button type="primary" @click="submitContractForm()" size="medium">
          保存
        </el-button>
      </span>
    </el-dialog>

    <!-- 收缴弹窗 -->
    <el-dialog
      title="租金收缴"
      :visible.sync="rentCollectDlgVisible"
      width="520px"
      custom-class="rent-collect-dialog"
      :append-to-body="true"
      @close="resetRentForm"
    >
      <div class="rent-collect-content">
        <div class="header-info-display">
          <p>合同编号：{{ currentContractNo }}</p>
          <p>资源名称：{{ currentResourceName }}</p>
          <p>租客名称：{{ currentPartyBName }}</p>
          <p>月租金：¥{{ currentPrice }}</p>
        </div>

        <!-- 表单录入区域 -->
        <el-form
          :model="rentCollectForm"
          :rules="rentCollectRules"
          ref="rentFormRef"
          label-position="top"
        >
          <!-- 缴费周期 -->
          <el-form-item label="缴费周期" prop="id">
            <el-select
              v-model="rentCollectForm.id"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="opt in rentRecords"
                :key="opt.id"
                :label="opt.payPeriod"
                :value="opt.id"
              />
            </el-select>
          </el-form-item>

          <!-- 实收金额 -->
          <el-form-item label="实收金额" prop="amountPaid">
            <el-input
              v-model.number="rentCollectForm.amountPaid"
              placeholder="请输入实收金额"
            />
          </el-form-item>

          <!-- 缴费日期 -->
          <el-form-item label="缴费日期" prop="payDate">
            <el-date-picker
              v-model="rentCollectForm.payDate"
              type="date"
              placeholder="请选择缴费日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>

          <!-- 上传凭证 -->
          <el-form-item label="上传凭证" prop="url">
            <el-upload
              class="rent-voucher-uploader"
              action="https://jsonplaceholder.typicode.com/posts/"
              :limit="1"
              :file-list="voucherFileList"
              :on-success="handleVoucherSuccess"
            >
              <el-button size="small" icon="el-icon-upload2"
                >上传缴费凭证</el-button
              >
            </el-upload>
          </el-form-item>
        </el-form>
      </div>

      <!-- 底部按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="rentCollectDlgVisible = false"
          >关闭</el-button
        >
        <el-button size="medium" type="primary" @click="submitRentCollect()"
          >保存</el-button
        >
      </span>
    </el-dialog>

    <!-- 合同解约弹窗 -->
    <el-dialog
      title="合同解约"
      :visible.sync="breakDialogVisible"
      width="520px"
      custom-class="rent-collect-dialog"
      :append-to-body="true"
      @close="resetRentForm"
    >
      <div class="rent-collect-content">
        <div class="header-info-display">
          <p>合同编号：{{ currentContractNo }}</p>
          <p>资源名称：{{ currentResourceName }}</p>
          <p>租客名称：{{ currentPartyBName }}</p>
          <p>月租金：¥{{ currentPrice }}</p>
        </div>

        <!-- 解约表单区 -->
        <el-form
          :model="breakForm"
          :rules="breakRules"
          ref="breakForm"
          label-position="top"
          class="custom-form"
        >
          <!-- 解约日期 -->
          <el-form-item label="解约日期" prop="terminationDate" required>
            <el-date-picker
              v-model="breakForm.terminationDate"
              type="date"
              placeholder="请选择日期"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>

          <!-- 解约原因 -->
          <el-form-item label="解约原因" prop="terminationReason">
            <el-input
              type="textarea"
              v-model="breakForm.terminationReason"
              placeholder="请填写解约原因"
              :rows="4"
            />
          </el-form-item>

          <!-- 押金退还情况 -->
          <el-form-item label="押金退还情况" prop="refundType">
            <el-radio-group v-model="breakForm.refundType">
              <el-radio
                v-for="option in refundTypeList"
                :key="option.value"
                :label="option.value"
              >
                {{ option.label }}
              </el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- 上传凭证 -->
          <el-form-item label="上传凭证" prop="fileList">
            <el-upload
              action="#"
              :auto-upload="false"
              :on-change="handleBreakFileChange"
              :on-remove="handleBreakFileRemove"
              :file-list="breakFileList"
              multiple
            >
              <el-button size="small" icon="el-icon-upload2" class="upload-btn">
                上传解约协议
              </el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>

      <!-- 底部操作按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleBreakCancel" size="medium">关闭</el-button>
        <el-button type="primary" @click="handleBreakContact" size="medium">
          确认
        </el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import _ from "lodash";
import config from "../../conf/config.js";
import { mapState, mapActions, mapMutations } from "vuex";
import { formatDate, formatDateTime } from "../../utils/dateUtil.js";
import { changeNumMoneyToChinese } from "@/utils/moneyUtil";
import {
  filterEmptyFields,
  mapValuesToArray,
  commonFormatter,
} from "../../utils/tool.js";

const TAG = "合同管理";
const SAVE_TYPE = {
  CONTRACT: "CONTRACT", // 合同
  INTENTION: "INTENTION", // 意向书
  TRANS: "trans",
  EDIT: "edit", // 编辑已有合同
};
export default {
  name: "ContractManagement",

  data() {
    // 手机号校验规则
    const checkPhone = (rule, value, callback) => {
      const reg = /^1[3-9]\d{9}$/;
      if (!value) {
        return callback(new Error("请输入租客电话"));
      }
      if (!reg.test(value)) {
        callback(new Error("请输入合法的电话号码"));
      } else {
        callback();
      }
    };

    return {
      currentContactId: "", // 合同编号
      currentContractNo: "", // 合同编号
      currentResourceName: "", // 资源名称
      currentPartyBName: "", // 租客名称
      currentPrice: "", // 月租金
      saveType: SAVE_TYPE.CONTRACT,
      currentPage: 1,
      currentPageSize: 10,
      // 筛选条件变量
      filters: {
        contractNo: "", // 合同编号：
        currentStatus: "", // 租控状态
        partyBName: "", // 租客名称
        paymentStatus: "", // 缴费状态
        resourceNoAndName: "", //	资源编号/名称
      },
      // 顶部汇总统计配置 (一比一还原图中文案及颜色)
      summaryCards: [
        {
          label: "总资源数",
          value: "",
          key: "totalCount",
          color: "#409EFF",
        },
        {
          label: "已出租",
          value: "",
          key: "rentedCount",
          color: "#67C23A",
        },
        {
          label: "空置可租",
          value: "",
          key: "availableCount",
          color: "#E6A23C",
        },
        {
          label: "装修中",
          value: "",
          key: "renovatingCount",
          color: "#722ed1",
        },
        {
          label: "已预订",
          value: "",
          key: "reservedCount",
          color: "#409EFF",
        },
        {
          label: "本月到期",
          value: "",
          key: "expiringCount",
          color: "#F56C6C",
        },
      ],
      //-----------------------抽屉弹窗部分--------------------------
      drawerVisible: false, // 控制抽屉显示
      activeTab: "basic", // 当前激活页签
      // 基本信息数据 (对应图1)
      basicInfo: [
        { label: "合同编号", value: "", key: "contractNo" },
        { label: "租控状态", value: "", key: "currentStatus" },
        { label: "资源编号", value: "", key: "resourceNo" },
        { label: "资源名称", value: "", key: "resourceName" },
        { label: "资源类型", value: "", key: "resourceType" },
        { label: "所属项目", value: "", key: "project" },
        { label: "租客名称", value: "", key: "partyBName" },
        { label: "租客电话", value: "", key: "partyBPhone" },
        { label: "面积", value: "", key: "area" },
        { label: "租金单价", value: "", key: "rentPrice" },
        { label: "月租金", value: "", key: "price" },
        { label: "支付方式", value: "", key: "rentCycle" },
        { label: "押金金额", value: "", key: "deposit" },
        { label: "缴费日期", value: "", key: "signDate" },
        { label: "签约日期", value: "", key: "signDate" },
        { label: "到期日期", value: "", key: "expiryDate" },
      ],

      attachmentList: [{}],
      // 租金记录数据 (对应图2)
      rentColumns: [
        { label: "缴费周期", key: "payPeriod" },
        { label: "实收金额", key: "amountPaid" },
        { label: "缴费日期", key: "payDate" },
        { label: "操作人", key: "createBy" },
        { label: "状态", key: "paymentStatus" },
      ],
      rentRecords: [],
      // 关联资源数据 (对应图3)
      resourceInfo: [
        { label: "资源编号", value: "", key: "resourceNo" },
        { label: "资源名称", value: "", key: "resourceName" },
        { label: "所属项目", value: "", key: "communityId" },
      ],

      // 表头统一样式
      tableHeaderStyle: {
        backgroundColor: "#f8f9fb",
        color: "#303133",
        fontSize: "13px",
      },

      //----------------新增合同部分-----------
      addDialogVisible: false, // 控制新增/编辑合同共用弹窗显示

      // 资源编号选项数组
      resourceOptionList: ["1", "2", "3", "4"],

      // 合同表单数据
      contractForm_old: {
        partyaId: "", // 出租方
        resourceType: "", // 资产类型 接口文档上没有
        resourceId: "", // 资源编号
        contractName: "", // 合同名称
        partyBName: "", // 租客名称
        partyBPhone: "", // 租客电话
        partyBAddress: "", // 租客地址
        signDate: "", // 签约日期
        expiryDate: "", // 到期日期
        unitPrice: "", // 租金单价
        price: "", // 月租金
        rentCycle: "", // 支付方式
        deposit: "", // 押金金额
        contractAmount: "", // 合同金额
        content: "", // 合同备注
        url: "", // 附件地址
      },

      // 合同表单数据
      contractForm: {
        partyaId: "", // 出租方
        communityId: "", // 所属项目ID,示例值(1)
        content: "", //  合同备注
        contractAmount: "", // 合同金额,示例值(120000)
        contractName: "", // 合同名称,示例值(商铺租赁合同)
        contractNo: "", // 合同/意向书编号,示例值(HT2024001)
        contractType: "", // 	合同类型：CONTRACT-合同，INTENTION-意向书,可用值:CONTRACT,INTENTION,UNDEFINED,示例值(CONTRACT)
        deposit: "", // 押金/定金,示例值(10000)
        expiryDate: "", // 到期日期,示例值(2025-12-31)
        id: "", // 不用
        partyBAddress: "", // 乙方地址,示例值(北京市海淀区XX路XX号)
        partyBContact: "", // 	乙方联系人,示例值(李四)
        partyBName: "", // 		乙方名称,示例值(XX商贸公司)
        partyBPhone: "", // 乙方联系电话,示例值(13900139000)
        price: "", // 	月租金,示例值(5000)
        remark: "", // 备注
        rentCycle: "", // 支付方式
        rentalArea: "", // 租赁面积（平方米）,示例值(100)
        resourceId: "", // 资源ID,示例值(1)
        signDate: "", // 签订日期,示例值(2024-01-01)
        unitPrice: "", // 租金单价（元/平方米/月）,示例值(50)
        url: "", //	附件URL
        resourceType: "", // 资产类型 接口文档上没有
      },
      // 甲方列表
      partyaList: [],

      // 表单校验规则
      contractRules: {
        resourceType: [
          { required: true, message: "请选择资产类型", trigger: "change" },
        ],
        resourceId: [
          { required: true, message: "请选择资源编号", trigger: "change" },
        ],
        partyaId: [
          { required: true, message: "请选择出租方", trigger: "change" },
        ],
        contractName: [
          { required: true, message: "请输入合同名称", trigger: "blur" },
        ],
        partyBName: [
          { required: true, message: "请输入租客名称", trigger: "blur" },
        ],
        partyBPhone: [
          { required: true, validator: checkPhone, trigger: "blur" },
        ],
        partyBAddress: [
          { required: false, message: "请输入租客地址", trigger: "blur" },
        ],
        signDate: [
          { required: true, message: "请选择签约日期", trigger: "change" },
        ],
        expiryDate: [
          { required: true, message: "请选择到期日期", trigger: "change" },
        ],
        unitPrice: [
          { required: true, message: "请输入租金单价", trigger: "blur" },
          { type: "number", message: "只能输入数字", trigger: "blur" },
        ],
        price: [
          { required: true, message: "请输入月租金", trigger: "blur" },
          { type: "number", message: "只能输入数字", trigger: "blur" },
        ],
        rentCycle: [
          { required: true, message: "请选择支付方式", trigger: "change" },
        ],
        deposit: [
          { required: true, message: "请输入押金金额", trigger: "blur" },
          { type: "number", message: "只能输入数字", trigger: "blur" },
        ],
        contractAmount: [
          { required: true, message: "请输入合同金额", trigger: "blur" },
          { type: "number", message: "只能输入数字", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请填写合同备注", trigger: "blur" },
        ],
      },

      fileList: [], // 上传文件列表

      //--------------------------收缴租金弹窗部分---------------------
      // 弹窗可见性
      rentCollectDlgVisible: false,

      // 租金收缴表单数据
      rentCollectForm: {
        id: "", // 缴费周期
        amountPaid: "", // 实收金额
        payDate: "", // 缴费日期
        url: "", // 上传后的凭证地址
      },

      // 表单校验规则
      rentCollectRules: {
        id: [{ required: true, message: "请选择缴费周期", trigger: "change" }],
        amountPaid: [
          { required: true, message: "请输入实收金额", trigger: "blur" },
          { type: "number", message: "金额必须为有效数字", trigger: "blur" },
        ],
        payDate: [
          { required: true, message: "请选择缴费日期", trigger: "change" },
        ],
      },

      // 上传组件维护的文件列表
      voucherFileList: [],

      // --------------------------------解约弹窗--------------------------
      // 弹窗可见性
      breakDialogVisible: false,

      // 顶部展示的静态/基础信息数据
      baseInfo: {
        contractNo: "HT-2026-001",
        resourceName: "南京软件谷A栋101铺",
        tenantName: "科技有限公司",
      },

      // 表单绑定变量
      breakForm: {
        terminationDate: "", // 解约日期
        terminationReason: "", // 解约原因
        refundType: "", // 押金退还类型：FULL-全额退还，PARTIAL-部分退还，NONE-不退还,可用值:FULL,NONE,PARTIAL,示例值(FULL)
      },

      breakFileList: [],

      // 押金退还选项配置 (使用v-for渲染)
      refundTypeList: [
        { label: "全额退还", value: "FULL" },
        { label: "部分退还", value: "PARTIAL" },
        { label: "不退还", value: "NONE" },
      ],

      // 表单校验规则
      breakRules: {
        terminateDate: [
          { required: true, message: "请选择解约日期", trigger: "change" },
        ],
        terminationReason: [
          { required: true, message: "请填写解约原因", trigger: "blur" },
        ],
        refundType: [
          { required: true, message: "请选择押金退还情况", trigger: "change" },
        ],
      },
    };
  },

  computed: {
    ...mapState("asset", [
      "contractList", // 合同列表
      "contractTotal", // 合同总条数
      "resourcePageData", // 资源列表
      "resourceTypeList", // 资产类型
      "currentStatusList", // 租控状态
      "paymentStatusList", // 缴费状态
      "rentCycleList", // 支付方式
      "communityId", // 支付方式
    ]),

    dialogTitle() {
      if (this.saveType == SAVE_TYPE.EDIT)  return "合同编辑";
      if (this.saveType == SAVE_TYPE.TRANS) return "转为合同";
      if (this.saveType == SAVE_TYPE.CONTRACT) return "添加合同";
      if (this.saveType == SAVE_TYPE.INTENTION) return "添加意向书";
      return "";
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions("asset", [
      "pageQueryContractsHandler", // 分页查询合同接口
      "saveContractHandler", // 保存合同（新增）
      "updateContractHandler", // 更新合同（编辑）
      "getResourcePageHandler", // 分页获取资源列表
      "getContractDetailHandler", // 获取合同详情
      "getResourceDetailHandler", // 获取合同详情
      "billPayHandler", // 账单缴费处理器
      "getStatisticsHandler", // 获取统计数据
      "intentionToContractHandler", // 意向书转合同
      "breakContactHandler", // 合同解约
      "uploadFile", // 上传文件
      "getContractPartyaListHandler", // 获取甲方列表
      "initiateContractSignHandler", // 发起合同电子签署
    ]),

    handleSizeChange(val) {
      console.log(TAG, "handleSizeChange: val=", val);
      this.currentPageSize = val;
      this.search();
    },

    handleCurrentChange(val) {
      console.log(TAG, "handleCurrentChange: val=", val);
      this.currentPage = val;
      this.search();
    },

    // 转换为合同
    transtoContract({ row }) {
      console.log(TAG, "转换为合同: row=", row);
      this.saveType = SAVE_TYPE.TRANS;
      this.currentContactId = row.id;
      this.openAddDialog();
      this.getContractDetail(true);
    },

    // 合同编辑 — 复用新增弹窗，saveType=EDIT，拉详情预填表单 + 设 content 到子组件
    handleEditContract({ row }) {
      console.log(TAG, "合同编辑: row=", row);
      this.saveType = SAVE_TYPE.EDIT;
      this.currentContactId = row.id;
      this.addDialogVisible = true;
      this.loadPartyaList();
      this.loadDetailForEdit();
    },

    // 编辑模式：拉详情 → 预填基本信息（content 直接赋给 contractForm.content，textarea 通过 v-model 绑定）
    async loadDetailForEdit() {
      try {
        const detail = await this.getContractDetailHandler(this.currentContactId);
        if (!detail) return;
        // 预填基本信息
        this.contractForm = {
          ...this.contractForm,
          id: detail.id || this.currentContactId,
          partyaId: _.get(detail, "partyaId") || this.contractForm.partyaId,
          contractName: _.get(detail, "contractName"),
          contractNo: _.get(detail, "contractNo"),
          partyBName: _.get(detail, "partyBName"),
          partyBPhone: _.get(detail, "partyBPhone"),
          partyBAddress: _.get(detail, "partyBAddress"),
          partyBContact: _.get(detail, "partyBContact"),
          signDate: _.get(detail, "signDate"),
          expiryDate: _.get(detail, "expiryDate"),
          contractAmount: _.get(detail, "contractAmount"),
          unitPrice: _.get(detail, "unitPrice"),
          price: _.get(detail, "price"),
          rentCycle: _.get(detail, "rentCycle"),
          deposit: _.get(detail, "deposit"),
          resourceId: _.get(detail, "resourceId"),
          resourceType: _.get(detail, "resourceType"),
          rentalArea: _.get(detail, "rentalArea"),
          url: _.get(detail, "url"),
          content: _.get(detail, "content") || "",
        };
      } catch (e) {
        console.error(TAG, "loadDetailForEdit 失败", e);
        this.$message.error("加载合同详情失败");
      }
    },

    // 合同编辑保存成功回调
    onEditContractSuccess() {
      this.pageQueryContractsHandler({
        pageNum: this.currentPage,
        pageSize: this.currentPageSize,
      });
    },

    // 解约
    breakContract({ row }) {
      console.log(TAG, "解约: row=", row);
      this.handleOpenBreak();
      this.currentContactId = row.id;
      this.getContractDetail();
    },

    // ====== 发起签署 ======
    // 判断合同是否可以发起签署：非已签署/签署中/已终止状态
    _canInitiateSign(row) {
      const status = (row.signStatus || row.contractStatus || "").toUpperCase();
      // 这些状态不能发起签署
      const blocked = ["SIGNED", "SIGNING", "EXECUTING", "TERMINATED", "COMPLETED"];
      return !blocked.includes(status);
    },
    handleInitiateSign({ row }) {
      console.log(TAG, "发起签署: row=", row);
      this.$confirm(
        `确认为合同「${row.contractName || row.contractNo}」发起电子签署吗？`,
        "发起签署",
        { type: "info", confirmButtonText: "确认发起", cancelButtonText: "取消", dangerouslyUseHTMLString: true }
      ).then(() => {
        this.$message({ message: "正在创建签署流程...", type: "info", duration: 1500 });
        this.initiateContractSignHandler({ contractId: row.id })
          .then((signData) => {
            console.log(TAG, "发起签署成功, signData=", signData);
            this.$message.success("签署已发起");
            // 如果后端返回 resultUrl（e签宝签署预览地址），可弹窗打开
            if (signData && signData.resultUrl) {
              // 可选：window.open(signData.resultUrl, '_blank');
              // 或者给一个按钮让用户手动跳转到签署页
            }
            this.pageQueryContractsHandler({ pageNum: this.currentPage, pageSize: this.currentPageSize });
          })
          .catch((err) => {
            console.error(TAG, "发起签署失败", err);
            this.$message.error(err && err.message ? err.message : "发起签署失败，请稍后重试");
          });
      }).catch(() => {});
    },

    handleTabClick(tab) {
      console.log("切换到页签:", tab.name);
    },

    handleDetailOpen({ row }) {
      this.drawerVisible = true;
      this.currentContactId = row.id;
      this.getContractDetail();
    },

    getContractDetail(transFlag = false) {
      const currentContactId = this.currentContactId;
      console.log(TAG, "getContractDetail id=", this.currentContactId);
      this.getContractDetailHandler(currentContactId).then((cDetail) => {
        const contractDetail = cDetail;
        const { resourceId, bills, signDate, id, url } = contractDetail;

        if (url) {
          this.attachmentList = [{ name: "", url: config.baseUrl + url }];
        } else {
          this.attachmentList = [];
        }

        this.getResourceDetailHandler(resourceId).then((rDetail) => {
          console.log(TAG, "handleDetailOpen rDetail=", rDetail);
          const reDetail = rDetail;
          try {
            delete reDetail.expiryDate;
          } catch (err) {
            console.log(TAG, "handleDetailOpen err=", err);
          }

          Object.assign(contractDetail, reDetail);
          const { contractNo, resourceName, partyBName, price } =
            contractDetail;
          this.currentContractNo = contractNo; // 合同编号
          this.currentResourceName = resourceName; // 资源名称
          this.currentPartyBNamee = partyBName; // 租客名称
          this.currentPricee = price; // 月租金
          this.basicInfo = mapValuesToArray(this.basicInfo, contractDetail);
          this.resourceInfo = mapValuesToArray(
            this.resourceInfo,
            contractDetail
          );
          this.rentRecords = bills;

          console.log(TAG, "getContractDetail detail=", contractDetail);
          // 转为合同（TRANS 模式）：强制 contractType 为 CONTRACT
          if (transFlag) {
            this.contractForm = {
              partyaId: _.get(contractDetail, "partyaId"),
              communityId: this.communityId,
              content: _.get(contractDetail, "content"),
              contractAmount: _.get(contractDetail, "contractAmount"),
              contractName: _.get(contractDetail, "contractName"),
              contractNo: _.get(contractDetail, "contractName"),
              contractType: "CONTRACT",
              deposit: _.get(contractDetail, "deposit"),
              expiryDate: _.get(contractDetail, "expiryDate"),
              id,
              partyBAddress: _.get(contractDetail, "partyBAddress"),
              partyBContact: _.get(contractDetail, "partyBContact"),
              partyBName: _.get(contractDetail, "partyBName"),
              partyBPhone: _.get(contractDetail, "partyBPhone"),
              price: _.get(contractDetail, "price"),
              remark: _.get(contractDetail, "remark"),
              rentCycle: _.get(contractDetail, "rentCycle"),
              rentalArea: _.get(contractDetail, "rentalArea"),
              resourceId: _.get(contractDetail, "resourceId"),
              signDate: signDate,
              unitPrice: _.get(contractDetail, "unitPrice"),
              url: _.get(contractDetail, "url"),
              resourceType: _.get(contractDetail, "resourceType"),
            };
          }
          console.log(TAG, "handleDetailOpen contractForm=", this.contractForm);
          console.log(TAG, "handleDetailOpen contractDetail=", contractDetail);
          console.log(TAG, "handleDetailOpen this.basicInfo=", this.basicInfo);
        });
      });
    },

    handleDetailClose() {
      this.drawerVisible = false;
    },
    /**
     * 初始化函数
     */
    init() {
      this.pageQueryContractsHandler({
        pageNum: this.currentPage,
        pageSize: this.currentPageSize,
      });

      this.getResourcePageHandler({
        page: 1,
        size: 100,
      });

      const params = {
        communityId: this.communityId, //所属项目
        floorId: "", // 楼栋ID
        resourceType: "", // 资源类型
      };

      const noEmptyParams = filterEmptyFields(params);
      this.getStatisticsHandler(noEmptyParams).then((obj) => {
        this.summaryCards = mapValuesToArray(this.summaryCards, obj);
        console.log(TAG, "init this.summaryCards=", this.summaryCards);
      });
    },

    /**
     * 查询
     */
    search() {
      const params = {
        pageNum: this.currentPage,
        pageSize: this.currentPageSize,
      };
      Object.assign(params, this.filters);
      const noEmpty = filterEmptyFields(params);
      console.log(TAG, "search params=", JSON.stringify(noEmpty));
      this.pageQueryContractsHandler(noEmpty);
    },

    /**
     * 重置
     */
    clearSearch() {
      this.filters = {
        contractNo: "",
        currentStatus: "",
        partyBName: "",
        paymentStatus: "",
        resourceNoAndName: "",
      };

      this.search();
    },

    // 提交表单 保存合同
    submitContractForm() {
      this.$refs.contractFormRef.validate((valid) => {
        if (!valid) { this.$message.error("请完善表单信息"); return false; }
        let params = filterEmptyFields(this.contractForm);
        let api, successMsg;
        if (this.saveType == SAVE_TYPE.EDIT) {
          params.id = this.contractForm.id || this.currentContactId;
          api = this.updateContractHandler;
          successMsg = "保存成功";
        } else if (this.saveType == SAVE_TYPE.TRANS) {
          api = this.intentionToContractHandler;
          successMsg = "成功转换为合同";
        } else {
          params.communityId = this.communityId;
          params.contractType = this.saveType;
          api = this.saveContractHandler;
          successMsg = "保存成功！数据已提交";
        }
        api(params).then(() => {
          this.$message.success(successMsg);
          this.addDialogVisible = false;
          this.clearDialog();
          this.pageQueryContractsHandler({ pageNum: this.currentPage, pageSize: this.currentPageSize });
        }).catch(err => { this.$message.error(err.msg); });
      });
    },

    clearDialog() {
      this.contractForm = {
        partyaId: "", communityId: "", content: "", contractAmount: "", contractName: "",
        contractNo: "", contractType: "", deposit: "", expiryDate: "", id: "",
        partyBAddress: "", partyBContact: "", partyBName: "", partyBPhone: "",
        price: "", remark: "", rentCycle: "", rentalArea: "", resourceId: "",
        signDate: "", unitPrice: "", url: "", resourceType: "",
      };
    },

    openAddContract() { this.saveType = SAVE_TYPE.CONTRACT; this.openAddDialog(); },
    openAddLOI()     { this.saveType = SAVE_TYPE.INTENTION; this.openAddDialog(); },

    openAddDialog() {
      this.addDialogVisible = true;
      this.loadPartyaList();
    },

    // 加载甲方列表
    loadPartyaList() {
      // 调用获取甲方列表接口
      this.getContractPartyaListHandler()
        .then((res) => {
          this.partyaList = res || [];
        })
        .catch((error) => {
          console.error("加载出租方列表失败：", error);
          this.$message.error("加载出租方列表失败");
        });
    },

    closeAddDialog() {
      this.addDialogVisible = false;
      this.clearDialog();
    },

    // 重置表单
    resetContractForm() {
      this.$refs.contractFormRef.resetFields();
      this.fileList = [];
    },

    //--------------------------收缴租金-------------------------

    openPayDialogRow({ row }) {
      this.openPayDialog();
      this.currentContactId = row.id;
      this.getContractDetail();
    },
    /**
     * 打开租金收缴弹窗
     */
    openPayDialog() {
      this.rentCollectDlgVisible = true;
    },

    /**
     * 关闭租金收缴弹窗
     */
    closePayDialog() {
      this.rentCollectDlgVisible = false;
    },

    /**
     * 提交租金收缴信息
     * 验证表单数据，验证通过后提交并关闭弹窗
     */
    submitRentCollect() {
      this.$refs.rentFormRef.validate((valid) => {
        if (valid) {
          console.log("提交收缴数据：", this.rentCollectForm);

          this.billPayHandler(this.rentCollectForm).then((res) => {
            this.closePayDialog();
            this.getContractDetail();
            this.search();
          });
        } else {
          return false;
        }
      });
    },

    /**
     * 凭证文件上传成功回调函数
     * @param {Object} res - 上传接口响应数据
     * @param {Object} file - 上传文件对象
     */
    handleVoucherSuccess(res, file) {
      this.rentCollectForm.url = file.url || "mock-url-path";
      this.$message.success("凭证上传成功");
    },

    /**
     * 重置租金收缴表单
     * 清空表单字段和文件列表
     */
    resetRentForm() {
      this.$refs.rentFormRef.resetFields();
      this.voucherFileList = [];
      this.rentCollectForm.url = "";
    },

    _commonFormatter(row, field) {
      return commonFormatter(row, field);
    },

    // 打开弹窗方法
    handleOpenBreak() {
      this.breakDialogVisible = true;
    },

    // 打开弹窗方法
    handleCloseBreak() {
      this.breakDialogVisible = false;
    },

    // 处理文件改变（上传）
    handleBreakFileChange(file, fileList) {
      this.breakFileList = fileList;
      console.log("当前文件列表:", fileList);
    },

    // 处理文件删除
    handleBreakFileRemove(file, fileList) {
      this.breakFileList = fileList;
    },

    // 取消操作
    handleBreakCancel() {
      this.breakDialogVisible = false;
      this.resetBreakForm();
    },

    resetBreakForm() {
      this.breakForm = {
        terminationDate: "", // 解约日期
        terminationReason: "", // 解约原因
        refundType: "", // 押金退还类型：FULL-全额退还，PARTIAL-部分退还，NONE-不退还,可用值:FULL,NONE,PARTIAL,示例值(FULL)
      };
    },

    // 提交校验并执行
    handleBreakContact() {
      this.$refs.breakForm.validate((valid) => {
        if (valid) {
          const params = {};

          console.log(
            TAG,
            "handleBreakContact params=",
            this.breakForm.terminationDate
          );

          Object.assign(params, this.breakForm, {
            contractId: this.currentContactId,
            terminationDate: formatDateTime(this.breakForm.terminationDate),
            url: "",
          });

          console.log(
            TAG,
            "handleBreakContact params=",
            JSON.stringify(params)
          );

          this.breakContactHandler(params).then((res) => {
            this.$message.success("解约成功");
            this.search();
            this.handleCloseBreak();
            this.resetBreakForm();
          });
        } else {
          console.log("表单校验失败");
          return false;
        }
      });
    },

    // 处理上传成功
    handleUploadSuccess(response, file, fileList) {
      console.log(TAG, "handleUploadSuccess, response=", response);
      console.log(TAG, "handleUploadSuccess, file=", file);
      console.log(TAG, "handleUploadSuccess, fileList=", fileList);
      this.$message.success("附件上传成功");
    },

    beforeUpload(file) {
      // const isImage = file.type.indexOf("image/") === 0;
      // const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isImage) {
      //   this.$message.error("格式不正确");
      // }
      // if (!isLt2M) {
      //   this.$message.error("超出文件上传上限");
      // }
      // return isImage && isLt2M;
      return true;
    },

    async handleUpload({ file }) {
      try {
        const formData = new FormData();
        formData.append("file", file);
        const url = await this.uploadFile(formData);
        console.log(TAG, "handleUpload url=", url);
        this.contractForm.url = url;
      } catch (error) {
        this.$message.error(error.message || this.$t("upload.uploadFailed"));
      }
    },

    /**
     * 处理文件下载
     * @param {Object} file 文件对象
     */
    handleDownload(file) {
      if (!file.url) {
        this.$message.warning("获取不到下载链接");
        return;
      }

      const link = document.createElement("a");
      link.style.display = "none";
      link.href = file.url;
      link.setAttribute("download", file.name); // 尝试指定下载文件名
      link.target = "_blank"; // 兼容处理，新标签页打开

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style lang="scss" scoped>
/* 颜色规范定义 */
$bg-main: #f4f6f9; // 全局底色
$bg-white: #ffffff; // 卡片白色背景
$color-primary: #409eff; // 品牌蓝
$color-success: #67c23a; // 成功绿
$color-warning: #e6a23c; // 警告橙
$color-danger: #f56c6c; // 本月到期/危险红
$color-purple: #722ed1; // 装修紫
$border-color: #ebeef5; // 边框颜色
$text-secondary: #909399; // 次要文字灰色

.contract-management-container {
  padding: 16px;
  background-color: $bg-main;
  min-height: 100vh;
  font-family: Arial, sans-serif;

  /* 顶部统计卡片 */
  .summary-header {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 16px;
    flex-wrap: wrap;

    .summary-card {
      flex: 1;
      min-width: 180px;
      background: $bg-white;
      padding: 16px 20px;
      border-radius: 4px;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);

      .summary-label {
        font-size: 13px;
        color: $text-secondary;
        margin-bottom: 10px;
      }
      .summary-value {
        font-size: 24px;
        font-weight: bold;
        .arrow-up {
          font-size: 16px;
          margin-left: 2px;
        }
      }
    }
  }

  /* 筛选区域 */
  .filter-wrapper {
    background: $bg-white;
    padding: 15px 20px;
    border-radius: 4px;
    margin-bottom: 16px;

    .search-form {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 15px;

      .form-item {
        display: flex;
        align-items: center;
        .label {
          font-size: 13px;
          font-weight: bold;
          white-space: nowrap;
        }
      }

      .button-group {
        display: flex;
        gap: 8px;
        .btn-add-contract {
          margin-left: 10px;
        }
        .btn-add-intent {
          background-color: #1890ff;
          border-color: #1890ff;
        }
      }
    }
  }

  /* 租控状态彩色文字 */
  .status-cell {
    font-weight: bold;
    &.status-green,
    &.status-RENTED,
    &.status-AVAILABLE {
      color: $color-success;
    }
    &.status-purple {
      color: $color-purple;
    }
    &.status-blue,
    &.status-RENOVATING {
      color: $color-primary;
    }
    &.status-red,
    &.status-RESERVED {
      color: $color-primary;
    }
  }

  /* 表格样式 */
  .table-container {
    background: $bg-white;
    padding: 15px;
    border-radius: 4px;

    /* 文档类型标签样式 */
    .doc-tag {
      padding: 2px 6px;
      border-radius: 2px;
      font-size: 12px;
      color: #fff;
      &.bg-blue {
        background-color: #91d5ff;
        color: #1890ff;
        border: 1px solid #91d5ff;
      }
      &.bg-orange {
        background-color: #ffe58f;
        color: #d48806;
        border: 1px solid #ffe58f;
      }
    }

    /* 缴费状态文字颜色 */
    .pay-status {
      font-weight: bold;
      &.text-PAID,
      &.text-green {
        color: $color-success;
      }

      &.text-OVERDUE,
      &.text-red {
        color: $color-danger;
      }

      &.text-UNPAID,
      &.text-black {
        color: #333;
      }
    }

    .text-red {
      color: $color-danger;
    }

    /* 分页器样式 */
    .pagination-bar {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      span {
        font-size: 13px;
        color: #606266;
        margin-right: 15px;
      }
    }
  }
}

/* 响应式调整 */
@media screen and (max-width: 1500px) {
  .summary-header .summary-card {
    min-width: 30%;
  }
}

@media screen and (max-width: 1200px) {
  .filter-wrapper .search-form {
    gap: 10px;
  }
}

/* 颜色变量定义 */
$primary-color: #1890ff; /* 主题品牌蓝 */
$text-main: #303133; /* 主要文字颜色 */
$text-secondary: #606266; /* 次要文字颜色 */
$text-placeholder: #909399; /* 占位/辅助文字 */
$border-color: #ebeef5; /* 基础边框颜色 */
$bg-light: #fbfbfb; /* 详情标签背景色 */
$bg-content: #fafafa; /* 内容区背景色 */
$success-color: #67c23a; /* 已缴费绿色 */
$fail-color: #ff0000; /* 未缴费红色 */

.custom-contract-drawer {
  .drawer-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #fff;

    .drawer-header {
      padding: 18px 20px;
      border-bottom: 1px solid $border-color;
      .header-left {
        display: flex;
        align-items: center;
        .close-btn {
          margin-right: 12px;
          cursor: pointer;
          font-size: 18px;
          color: $text-placeholder;
          &:hover {
            color: $primary-color;
          }
        }
        .title {
          font-size: 16px;
          font-weight: 600;
          color: $text-main;
        }
      }
    }

    .tabs-wrapper {
      padding: 0 20px;
      ::v-deep .el-tabs__header {
        margin-bottom: 0;
      }
      ::v-deep .el-tabs__item {
        height: 50px;
        line-height: 50px;
        font-size: 13px;
      }
      ::v-deep .el-tabs__nav-wrap::after {
        height: 1px;
      }
    }

    .scroll-body {
      flex: 1;
      padding: 20px;
      overflow-y: auto;
      background-color: $bg-content;

      .tab-content {
        /* 通用卡片样式 */
        .section-card {
          background: #fff;
          border: 1px solid $border-color;
          border-radius: 4px;
          padding: 20px;
          margin-bottom: 20px;
          &.no-padding {
            padding: 10px;
          }

          .section-title {
            margin: 0 0 16px 0;
            font-size: 14px;
            color: $text-main;
            font-weight: 600;
            text-align: left;
          }
        }

        /* 信息网格布局 (图1 & 图3) */
        .info-grid {
          display: flex;
          flex-wrap: wrap;
          border-top: 1px solid $border-color;
          border-left: 1px solid $border-color;

          .info-item {
            width: 50%; /* 默认两列 */
            display: flex;
            box-sizing: border-box;
            border-right: 1px solid $border-color;
            border-bottom: 1px solid $border-color;
            min-height: 40px;

            .info-label {
              width: 120px;
              background-color: $bg-light;
              padding: 10px 12px;
              color: $text-secondary;
              font-size: 13px;
              border-right: 1px solid $border-color;
              display: flex;
              align-items: center;
            }
            .info-value {
              flex: 1;
              padding: 10px 12px;
              font-size: 13px;
              color: $text-main;
              display: flex;
              align-items: center;
            }
          }

          /* 关联资源单列模式 (图3) */
          &.single-column {
            .info-item {
              width: 100%;
            }
          }
        }

        /* 操作栏 (图2) */
        .action-bar {
          margin-bottom: 15px;
          text-align: left;
        }

        /* 状态标记 */
        .status-success-text {
          color: $success-color;
          font-weight: bold;
        }
        .status-success-tag,
        .status-payment-PAID {
          color: $success-color;
          background: rgba(103, 194, 58, 0.1);
          padding: 2px 8px;
          border-radius: 2px;
          font-weight: 500;
        }
        .status-fail-tag,
        .status-payment-OVERDUE,
        .status-payment-UNPAID {
          color: $fail-color;
          background: rgba(103, 194, 58, 0.1);
          padding: 2px 8px;
          border-radius: 2px;
          font-weight: 500;
        }

        /* 附件为空 (图1) */
        .empty-holder {
          text-align: center;
          padding: 40px 0;
          color: $text-placeholder;
          .empty-icon {
            font-size: 40px;
            margin-bottom: 10px;
            opacity: 0.3;
          }
          p {
            margin: 0;
            font-size: 13px;
          }
        }

        /* 底部中央按钮 (图3) */
        .footer-actions {
          display: flex;
          justify-content: center;
          margin-top: 20px;
        }
      }
    }
  }
}

/* 响应式适配 */
@media screen and (max-width: 1400px) {
  ::v-deep .el-drawer {
    width: 60% !important;
  }
}

@media screen and (max-width: 992px) {
  ::v-deep .el-drawer {
    width: 90% !important;
  }
  .info-item {
    width: 100% !important;
  } /* 窄屏切换为单列 */
}

//---新增合同弹窗部分
/* 弹窗专用颜色变量 */
$dlg-primary-blue: #1890ff; /* 弹窗主蓝色 */
$dlg-border-color: #dcdfe6; /* 输入框边框色 */
$dlg-label-color: #606266; /* 字段标签颜色 */
$dlg-placeholder: #c0c4cc; /* 占位文字颜色 */
$dlg-btn-cancel: #f4f4f5; /* 取消按钮背景 */

.add-contract-dialog {
  /* 深度修改 Element UI 样式以还原图片 */
  ::v-deep .el-dialog__header {
    padding: 20px;
    border-bottom: 1px solid #f0f0f0;
    .el-dialog__title {
      font-size: 16px;
      font-weight: 600;
    }
  }

  ::v-deep .el-dialog__body {
    padding: 20px 30px;
  }

  .contract-form-grid {
    .form-row {
      display: flex;
      gap: 30px; /* 栅格间距 */
      margin-bottom: 5px;

      .flex-1 {
        flex: 1;
      }
    }

    /* 标签加星号样式强化 */
    ::v-deep .el-form-item__label {
      padding-bottom: 8px;
      font-weight: 500;
      color: $dlg-label-color;
      font-size: 13px;
      line-height: 1;

      &::before {
        margin-right: 4px;
      }
    }

    /* 上传按钮样式定制 */
    .contract-uploader {
      ::v-deep .el-button {
        border: 1px solid $dlg-border-color;
        background: #fff;
        color: $dlg-label-color;
        padding: 9px 15px;
        &:hover {
          color: $dlg-primary-blue;
          border-color: $dlg-primary-blue;
        }
      }
    }

    /* 文本域调整 */
    ::v-deep .el-textarea__inner {
      font-family: inherit;
      resize: none;
    }

    /* 合同备注 — 嵌入 ContractEdit 子组件 */
    .contract-content-item {
      margin-top: 10px;
      .el-form-item__content {
        display: block;
        width: 100%;
      }
    }
  }

  /* 底部按钮还原 */
  .dialog-footer {
    .el-button {
      padding: 10px 25px;
      &--default {
        background-color: #fff;
        border-color: $dlg-border-color;
      }
      &--primary {
        background-color: $dlg-primary-blue;
        border-color: $dlg-primary-blue;
      }
    }
  }
}

/* 响应式适配 */
@media screen and (max-width: 850px) {
  ::v-deep .el-dialog {
    width: 95% !important;
  }
  .form-row {
    flex-direction: column;
    gap: 0 !important;
  }
}

::v-deep .el-form-item__label {
  width: 100%;
}
::v-deep .el-form-item__content {
  text-align: left;
}
::v-deep .el-dialog__header {
  text-align: left;
}

/* 租金收缴弹窗专用颜色变量 */
$rent-primary: #1890ff; /* 品牌主色 */
$rent-text-main: #303133; /* 文字主色 */
$rent-text-grey: #606266; /* 描述文字颜色 */
$rent-border: #dcdfe6; /* 输入框边框色 */
$rent-bg: #fff; /* 背景色 */

/* 弹窗深度样式还原 */
.rent-collect-dialog {
  ::v-deep .el-dialog__header {
    border-bottom: 1px solid #f0f2f5;
    padding: 16px 20px;
    .el-dialog__title {
      font-size: 15px;
      font-weight: 600;
      color: $rent-text-main;
    }
  }

  ::v-deep .el-dialog__body {
    padding: 20px 24px 10px;
  }

  .rent-collect-content {
    /* 顶部静态信息样式 */
    .header-info-display {
      margin-bottom: 20px;
      p {
        margin: 0 0 8px 0;
        font-size: 13px;
        color: $rent-text-main;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    /* 表单项样式微调 */
    ::v-deep .el-form-item {
      margin-bottom: 18px;
    }

    ::v-deep .el-form-item__label {
      line-height: 1;
      padding-bottom: 10px;
      font-size: 13px;
      color: $rent-text-main;
      font-weight: 500;
      /* 必填星号样式 */
      &::before {
        margin-right: 4px;
        color: #f56c6c;
      }
    }

    /* 上传按钮样式一比一还原 */
    .rent-voucher-uploader {
      ::v-deep .el-button--small {
        border-color: $rent-border;
        background: $rent-bg;
        color: $rent-text-grey;
        padding: 9px 12px;
        &:hover {
          color: $rent-primary;
          border-color: $rent-primary;
        }
      }
    }
  }

  /* 底部操作区一比一还原 */
  .dialog-footer {
    .el-button {
      min-width: 64px;
      &--primary {
        background-color: $rent-primary;
        border-color: $rent-primary;
      }
      &--default {
        border-color: $rent-border;
      }
    }
  }
}

/* 响应式适配 */
@media screen and (max-width: 550px) {
  ::v-deep .el-dialog {
    width: 90% !important;
  }
}
</style>
